<template>
  <div>
    <div class="panel-header">
      <div>
        <div class="panel-title">数据权限定义</div>
        <div class="panel-desc">
          定义业务表上的数据权限口径（编码/类型/业务表/过滤字段），岗位默认权限与用户特殊权限均通过编码引用本表
        </div>
      </div>
      <a-button type="primary" icon="plus" @click="openAdd">新增定义</a-button>
    </div>

    <a-table
      bordered
      rowKey="id"
      size="middle"
      :loading="loading"
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :scroll="{ x: 1100 }"
    >
      <template slot="typeCol" slot-scope="text">
        <a-tag :color="typeColor(text)">{{ typeName(text) }}</a-tag>
      </template>
      <template slot="fieldCol" slot-scope="text">
        <a-tag v-if="text === '*'" color="orange">*（全表）</a-tag>
        <span v-else>{{ text }}</span>
      </template>
      <template slot="actionCol" slot-scope="text, record">
        <a-space>
          <a @click="openEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a class="danger-link" @click="deleteText(record)">删除</a>
        </a-space>
      </template>
    </a-table>

    <!-- 新增/编辑定义 -->
    <a-modal
      :title="editingId ? '编辑数据权限定义' : '新增数据权限定义'"
      :visible="modalVisible"
      :confirm-loading="modalLoading"
      width="640px"
      @ok="submitModal"
      @cancel="modalVisible = false"
    >
      <a-form-model
        ref="defineForm"
        :model="modalForm"
        :rules="modalRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-form-model-item label="权限编码" prop="code">
          <a-input v-model="modalForm.code" :disabled="!!editingId" placeholder="如：contract_id" />
        </a-form-model-item>
        <a-form-model-item label="权限名称" prop="name">
          <a-input v-model="modalForm.name" placeholder="如：合同详情权限" />
        </a-form-model-item>
        <a-form-model-item label="权限类型" prop="type">
          <a-auto-complete
            v-model="modalForm.type"
            :data-source="typeOptions"
            placeholder="global/personal/dept/cross_dept/url 等，可自定义"
          />
        </a-form-model-item>
        <a-form-model-item label="业务表名" prop="tableName">
          <a-input v-model="modalForm.tableName" placeholder="真实业务表名，如 prj_contract" />
        </a-form-model-item>
        <a-form-model-item label="过滤字段" prop="tableField">
          <a-input v-model="modalForm.tableField" placeholder="如 id、create_by、dept_id；* 表示全表放行" />
        </a-form-model-item>
        <a-form-model-item label="取值接口">
          <a-input v-model="modalForm.url" placeholder="url类型选值接口，如 /project-service/contract/all（可空）" />
        </a-form-model-item>
        <a-form-model-item label="值字段">
          <a-input v-model="modalForm.urlField" placeholder="url类型取值字段（可空）" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="modalForm.remarks" :rows="2" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  fetchDataPermissionList,
  addDataPermission,
  updateDataPermission,
  deleteDataPermission,
} from "@/api/setting/auth";

export default {
  name: "data-permission-define",

  data() {
    return {
      loading: false,
      list: [],
      columns: [
        { title: "编码", dataIndex: "code", width: 200 },
        { title: "名称", dataIndex: "name", width: 160 },
        { title: "类型", dataIndex: "type", width: 110, align: "center", scopedSlots: { customRender: "typeCol" } },
        { title: "业务表", dataIndex: "tableName", width: 180 },
        { title: "过滤字段", dataIndex: "tableField", width: 140, scopedSlots: { customRender: "fieldCol" } },
        { title: "取值接口", dataIndex: "url", ellipsis: true },
        { title: "备注", dataIndex: "remarks", width: 160, ellipsis: true },
        { title: "操作", width: 110, align: "center", scopedSlots: { customRender: "actionCol" } },
      ],
      modalVisible: false,
      modalLoading: false,
      editingId: null,
      modalForm: {},
      modalRules: {
        code: [{ required: true, message: "请输入权限编码" }],
        name: [{ required: true, message: "请输入权限名称" }],
        tableName: [{ required: true, message: "请输入业务表名" }],
        tableField: [{ required: true, message: "请输入过滤字段" }],
      },
      typeOptions: ["global", "personal", "dept", "cross_dept", "url"],
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    typeName(type) {
      const map = {
        global: "全部数据",
        personal: "仅本人",
        dept: "本部门",
        cross_dept: "跨部门",
        url: "接口取值",
        cosys: "协同",
      };
      return map[type] || type || "-";
    },
    typeColor(type) {
      const map = {
        global: "red",
        personal: "blue",
        dept: "cyan",
        cross_dept: "purple",
        url: "geekblue",
      };
      return map[type] || "default";
    },
    getList() {
      this.loading = true;
      fetchDataPermissionList()
        .then((res) => {
          this.loading = false;
          this.list = Array.isArray(res) ? res : [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openAdd() {
      this.editingId = null;
      this.modalForm = {
        code: undefined,
        name: undefined,
        type: undefined,
        tableName: undefined,
        tableField: undefined,
        url: undefined,
        urlField: undefined,
        remarks: undefined,
      };
      this.modalVisible = true;
    },
    openEdit(record) {
      this.editingId = record.id;
      this.modalForm = {
        code: record.code,
        name: record.name,
        type: record.type,
        tableName: record.tableName,
        tableField: record.tableField,
        url: record.url,
        urlField: record.urlField,
        remarks: record.remarks,
      };
      this.modalVisible = true;
    },
    submitModal() {
      this.$refs.defineForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.modalLoading = true;
        const req = this.editingId
          ? updateDataPermission({ ...this.modalForm, id: this.editingId })
          : addDataPermission(this.modalForm);
        req
          .then(() => {
            this.modalLoading = false;
            this.modalVisible = false;
            this.$message.success(this.editingId ? "修改成功" : "新增成功");
            this.getList();
          })
          .catch(() => {
            this.modalLoading = false;
          });
      });
    },
    deleteText(record) {
      const that = this;
      this.$confirm({
        title: `确认删除数据权限定义「${record.code}」吗？`,
        content: "删除后依赖该编码的岗位配置与用户授权将无法生成SQL，请先确认无引用。",
        onOk() {
          return deleteDataPermission(record.id).then(() => {
            that.$message.success("删除成功");
            that.getList();
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}
.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.panel-desc {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.danger-link {
  color: #f5222d;
}
</style>
